import React, { Component } from "react";
import { Button, Modal, FormControl } from "react-bootstrap";
import EditProfile from "../EditProfile/EditProfile";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    saveButtonTitle: "Save Changes",
    resetButtonTitle: "Reset",
  },
  ja: {
    saveButtonTitle: "変更を保存する",
    resetButtonTitle: "リセット",
  },
  es: {
    saveButtonTitle: "Guardar Cambios",
    resetButtonTitle: "Restablecer",
  },
});

class ProfileSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    //? Functions
  }

  componentWillMount() {}

  render() {
    return <EditProfile />;
  }
}

export default ProfileSetting;
